"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var GoodsActions = _interopRequireWildcard(require("../actions/GoodsActions"));

var TrialStateActions = _interopRequireWildcard(require("../actions/TrialStateActions"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodSubTypeGroups = _interopRequireDefault(require("../constants/GoodSubTypeGroups"));

var _GoodTypes = _interopRequireDefault(require("../constants/GoodTypes"));

var _HeaderTabs = _interopRequireDefault(require("../constants/HeaderTabs"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var authSelectors = _interopRequireWildcard(require("../selectors/auth"));

var _goodDetails = require("../selectors/goodDetails");

var _reviewInputInfo = require("../selectors/reviewInputInfo");

var _trialState = require("../selectors/trialState");

var _utils = require("../utils/utils");

var _AppHeader = _interopRequireDefault(require("../components/AppHeader"));

var _DashboardPage = _interopRequireDefault(require("../components/layout/DashboardPage"));

var _GoodDetailsPage = _interopRequireDefault(require("../components/goodDetails/GoodDetailsPage"));

var _LoadingWrapper = _interopRequireDefault(require("../components/LoadingWrapper"));

var _SearchBarContainer = _interopRequireDefault(require("./SearchBarContainer"));

var _constants = require("../lib/usage/constants");

var _withUsageTracking = _interopRequireDefault(require("./hocs/withUsageTracking"));

var _LoadingErrorPage = _interopRequireDefault(require("../components/LoadingErrorPage"));

var closeReviewModal = GoodsActions.closeReviewModal,
    onClickPurchaseErrorModalClose = GoodsActions.onClickPurchaseErrorModalClose,
    triggerReviewModal = GoodsActions.triggerReviewModal;

var LoadingErrorComponent = function LoadingErrorComponent() {
  return _react.default.createElement(_NavMarker.default, {
    name: "DETAIL_ERROR_LOAD"
  }, _react.default.createElement(_LoadingErrorPage.default, null));
};

var GoodDetailsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(GoodDetailsContainer, _Component);

  function GoodDetailsContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, GoodDetailsContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(GoodDetailsContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setDocumentTitle = function () {
      document.title = _I18n.default.text('MarketplaceUI.goodDetailsPage.documentTitle', {
        name: _this.props.goodDetails.get('goodName')
      });
    };

    _this.handleNavigateFromGoodDetailsReview = function () {
      var _this$props = _this.props,
          navigateFromGoodDetailsReview = _this$props.navigateFromGoodDetailsReview,
          routeParams = _this$props.routeParams;
      var goodNameUrlToken = routeParams.goodNameUrlToken,
          providerUrlToken = routeParams.providerUrlToken;
      navigateFromGoodDetailsReview(providerUrlToken, goodNameUrlToken);
    };

    _this.trackDetailsPageLinkClick = function (itemClicked) {
      _this.props.trackClickedLink(_constants.Screens.DETAILS, itemClicked);
    };

    _this.renderAppHeader = function () {
      var categoryFilter = 'all-products';

      if (_this.props.isTemplate || _this.props.isPack || _this.props.isEmailTemplate) {
        categoryFilter = _GoodSubTypeGroups.default.TEMPLATES;
      } else if (_this.props.isCustomModule) {
        categoryFilter = _GoodTypes.default.CUSTOM_MODULE;
      }

      return _react.default.createElement(_AppHeader.default, {
        currentTab: _HeaderTabs.default.STOREFRONT,
        searchBarComponent: _react.default.createElement(_SearchBarContainer.default, {
          screen: "details",
          categoryFilter: categoryFilter
        })
      });
    };

    return _this;
  }

  (0, _createClass2.default)(GoodDetailsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          getGoodDetails = _this$props2.getGoodDetails,
          getTrialState = _this$props2.getTrialState,
          isCustomer = _this$props2.isCustomer,
          previewMode = _this$props2.previewMode,
          routeParams = _this$props2.routeParams,
          trackPageview = _this$props2.trackPageview;
      trackPageview(_constants.Screens.DETAILS);
      var provider = routeParams.providerUrlToken;
      getGoodDetails(provider, routeParams.goodNameUrlToken, previewMode, isCustomer);

      if (isCustomer) {
        getTrialState();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          goodDetails = _this$props3.goodDetails,
          getGoodDetails = _this$props3.getGoodDetails,
          isCustomer = _this$props3.isCustomer,
          reviewModalOpen = _this$props3.reviewModalOpen,
          _this$props3$routePar = _this$props3.routeParams,
          providerUrlToken = _this$props3$routePar.providerUrlToken,
          goodNameUrlToken = _this$props3$routePar.goodNameUrlToken;
      var prevGoodDetails = prevProps.goodDetails,
          prevReviewModalOpen = prevProps.reviewModalOpen,
          _prevProps$routeParam = prevProps.routeParams,
          prevProviderUrlToken = _prevProps$routeParam.providerUrlToken,
          prevGoodNameUrlToken = _prevProps$routeParam.goodNameUrlToken;

      if (prevGoodDetails.get('requestStatus') === _RequestStatusTypes.default.PENDING && goodDetails.get('requestStatus') === _RequestStatusTypes.default.SUCCEEDED) {
        this.setDocumentTitle();
      }

      if (providerUrlToken !== prevProviderUrlToken || goodNameUrlToken !== prevGoodNameUrlToken) {
        getGoodDetails(providerUrlToken, goodNameUrlToken, false, isCustomer);
      }

      if (prevReviewModalOpen && !reviewModalOpen) {
        this.handleNavigateFromGoodDetailsReview();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetGoodDetails();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          auth = _this$props4.auth,
          canReview = _this$props4.canReview,
          canTrialMarketing = _this$props4.canTrialMarketing,
          goodDetails = _this$props4.goodDetails,
          goodFiltersAndPage = _this$props4.goodFiltersAndPage,
          hasPurchaseAccess = _this$props4.hasPurchaseAccess,
          isCustomModule = _this$props4.isCustomModule,
          isCustomer = _this$props4.isCustomer,
          isEmailTemplate = _this$props4.isEmailTemplate,
          isPack = _this$props4.isPack,
          isTemplate = _this$props4.isTemplate,
          location = _this$props4.location,
          previewMode = _this$props4.previewMode,
          reviewMode = _this$props4.reviewMode,
          routeParams = _this$props4.routeParams;
      return _react.default.createElement(_DashboardPage.default, {
        headerComponent: !previewMode && this.renderAppHeader(),
        pageLayout: "full-width",
        "data-selenium-selector": "good-details-container"
      }, _react.default.createElement(_LoadingWrapper.default, {
        ErrorComponent: LoadingErrorComponent,
        requestStatus: goodDetails.get('requestStatus')
      }, _react.default.createElement(_GoodDetailsPage.default, {
        auth: auth,
        canReview: canReview,
        canTrialMarketing: canTrialMarketing,
        closeReviewModal: this.props.closeReviewModal,
        goodFiltersAndPage: goodFiltersAndPage,
        goodNameUrlToken: routeParams.goodNameUrlToken,
        hasPurchaseAccess: hasPurchaseAccess,
        isCustomModule: isCustomModule,
        isCustomer: isCustomer,
        isEmailTemplate: isEmailTemplate,
        isPack: isPack,
        isTemplate: isTemplate,
        navigateFromGoodDetailsReview: this.handleNavigateFromGoodDetailsReview,
        onClickPurchaseErrorModalClose: this.props.onClickPurchaseErrorModalClose,
        packChildrenSubTypes: (0, _utils.getSubTypesFromPackCounts)(goodDetails.get('packCounts')),
        previewMode: previewMode,
        reviewMode: reviewMode,
        redirectUrl: location.query.redirectUrl,
        goodDetails: goodDetails,
        providerUrlToken: routeParams.providerUrlToken,
        trackLinkClick: this.trackDetailsPageLinkClick,
        triggerReviewModal: this.props.triggerReviewModal
      })));
    }
  }]);
  return GoodDetailsContainer;
}(_react.Component);

GoodDetailsContainer.propTypes = {
  auth: _react.PropTypes.object.isRequired,
  canReview: _react.PropTypes.bool.isRequired,
  canTrialMarketing: _react.PropTypes.bool.isRequired,
  closeReviewModal: _react.PropTypes.func.isRequired,
  getGoodDetails: _react.PropTypes.func.isRequired,
  getTrialState: _react.PropTypes.func.isRequired,
  goodDetails: _react.PropTypes.object.isRequired,
  goodFiltersAndPage: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  hasPurchaseAccess: _react.PropTypes.bool.isRequired,
  isCustomModule: _react.PropTypes.bool.isRequired,
  isCustomer: _react.PropTypes.bool.isRequired,
  isEmailTemplate: _react.PropTypes.bool.isRequired,
  isPack: _react.PropTypes.bool.isRequired,
  isTemplate: _react.PropTypes.bool.isRequired,
  location: _react.PropTypes.object.isRequired,
  navigateFromGoodDetailsReview: _react.PropTypes.func.isRequired,
  onClickPurchaseErrorModalClose: _react.PropTypes.func.isRequired,
  previewMode: _react.PropTypes.bool,
  resetGoodDetails: _react.PropTypes.func.isRequired,
  reviewModalOpen: _react.PropTypes.bool,
  reviewMode: _react.PropTypes.bool,
  routeParams: _react.PropTypes.shape({
    goodNameUrlToken: _react.PropTypes.string.isRequired,
    providerUrlToken: _react.PropTypes.string.isRequired
  }).isRequired,
  trackClickedLink: _react.PropTypes.func.isRequired,
  trackPageview: _react.PropTypes.func.isRequired,
  triggerReviewModal: _react.PropTypes.func.isRequired
};
GoodDetailsContainer.defaultProps = {
  previewMode: false,
  reviewMode: false
};

function mapStateToProps(state) {
  var goodDetails = state.goodDetails;
  var goodSubType = goodDetails.get('subType');
  var goodType = goodDetails.get('type');
  var isTemplate = goodType === _GoodTypes.default.COS_TEMPLATE;
  return {
    auth: state.auth,
    canReview: (0, _goodDetails.getCanReview)(state),
    canTrialMarketing: (0, _trialState.getCanTrial)(state, 'marketing-pro'),
    goodDetails: goodDetails,
    goodFiltersAndPage: state.directoryData.get('goodFiltersAndPage'),
    hasPurchaseAccess: authSelectors.getHasInstallAccess(state),
    isCustomModule: goodType === _GoodTypes.default.CUSTOM_MODULE,
    isCustomer: authSelectors.getIsCustomer(state),
    isEmailTemplate: isTemplate && goodSubType === _GoodSubTypes.default.EMAIL_TEMPLATES,
    isPack: goodType === _GoodTypes.default.PACK,
    isTemplate: isTemplate,
    reviewModalOpen: (0, _reviewInputInfo.getIsReviewModalOpen)(state)
  };
}

var mapDispatchToProps = {
  closeReviewModal: closeReviewModal,
  getGoodDetails: GoodsActions.getGoodDetails,
  getTrialState: TrialStateActions.fetchTrialState,
  navigateFromGoodDetailsReview: GoodsActions.navigateFromGoodDetailsReview,
  onClickPurchaseErrorModalClose: onClickPurchaseErrorModalClose,
  resetGoodDetails: GoodsActions.resetGoodDetails,
  triggerReviewModal: triggerReviewModal
};

var _default = (0, _redux.compose)((0, _withUsageTracking.default)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(GoodDetailsContainer);

exports.default = _default;
module.exports = exports.default;